import { dataHooks } from '@wix/data-hooks';

export const confirmDialogDataHooks = dataHooks<{
  main;
  completeBtn;
  cancelBtn;
}>('leave-the-challenge');
